import { TranslationKeys } from 'types/TranslationKeys'
import { IDepartment } from 'models/Department/IDepartment'

export interface ListProps {
  departments: IDepartment[] | null
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useList = (props: ListProps) => {
  return {
    ...props,
  }
}
